import {ChakraProvider} from '@chakra-ui/react';
import {ColorModeProvider} from './color-mode';
import {system} from 'providers/theme/config';
import React from 'react';

const ThemeProvider = (props: any) => {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
};

export default ThemeProvider;
